import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@/utils/styles';

const badgeVariants = cva(
  'inline-flex items-center rounded-md border gap-1 px-3 py-1 typography-btn-medium transition-colors focus:outline-none focus:ring-2 focus:ring-stroke-primary-bold focus:ring-offset-2 text-primary',
  {
    variants: {
      variant: {
        default: 'border-transparent bg-background',
        outline: 'border-stroke-primary-subtle',
      },
      size: {
        default: 'px-4 py-2',
        sm: 'px-3 py-1',
      },
    },
    defaultVariants: {
      size: 'default',
      variant: 'default',
    },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <div
      className={cn(badgeVariants({ size, variant }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
